import { useMutation, useQueryClient } from "@tanstack/react-query"
import { authService } from "../end-points/auth"
import { toast } from "@/hooks/use-toast"
import { useLocation } from "wouter"
import { TokenStorage } from "../../../shared/handle-local-storage"
import { useResetPasswordProps } from "@/pages/forgot-password/forgot-password.types"

interface CineBlocksErr extends Error {
  data: {
    statusCode: number
  }
}

export const useLogin = () => {
  return useMutation({
    mutationFn: (data: { login: string, password: string }) => authService.login(data),
    onSuccess: () => { },
    onError: (err: CineBlocksErr) => {
      console.log(err)
      if (err?.data?.statusCode === 401) {
        toast({
          title: "Erro ao realizar login",
          description: "Crendeciais inválidas!",
          variant: "destructive",
        })

        return
      }

      toast({
        title: "Erro ao realizar login",
        description: "Não foi possível realizar o login",
        variant: "destructive",
      })
    }
  })
}

export const useForgotPassword = ({ successCallback }: useResetPasswordProps) => {
  return useMutation({
    mutationFn: (data: { login: string }) => authService.forgotPassword(data),
    onSuccess: () => {
      if (successCallback) {
        successCallback()
      }
    },
    onError: (err) => {
      console.log(err)
      toast({
        title: "Erro ao redefinir senha",
        description: "Não foi possível redefinir a senha",
        variant: "destructive",
      })
    }
  })
}

export const useLogout = () => {
  const [, setLocation] = useLocation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      // Clear token from localStorage
      TokenStorage.remove()

      // Show success toast
      toast({
        title: "Logout realizado com sucesso",
        description: "Você foi desconectado da plataforma",
      })

      // Use window.location for guaranteed redirect (more reliable than wouter)
      window.location.href = '/login'
    },
    onError: (err: CineBlocksErr) => {
      console.log(err)

      // Even on error, logout client-side for security
      TokenStorage.remove()

      toast({
        title: "Logout realizado",
        description: "Você foi desconectado da plataforma",
      })

      // Use window.location for guaranteed redirect
      window.location.href = '/login'
    }
  })
}
